import { render, staticRenderFns } from "./UserTutorialComponent.vue?vue&type=template&id=cbf6140c&"
import script from "./UserTutorialComponent.vue?vue&type=script&lang=ts&"
export * from "./UserTutorialComponent.vue?vue&type=script&lang=ts&"
import style0 from "./UserTutorialComponent.vue?vue&type=style&index=0&id=cbf6140c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports